// Moved from `src/features/workspace/hooks/useQueryWorkspaceInvitations.ts`
// (now a shim) at AW1, ARCFE-984 — the same re-points as its workspaces
// sibling; see that file's header.
import { skipToken, useQuery } from '@tanstack/react-query';
import {
  GET_WORKSPACE_INVITATIONS,
  type ListWorkspaceInvitationsResponse,
} from '../../contracts';
import { listWorkspaceInvitations } from '../api/workspaces';
import { getWorkspaceDataConfig, isTransportError } from '../config';

export { GET_WORKSPACE_INVITATIONS };

export const invalidateWorkspaceInvitations = () =>
  getWorkspaceDataConfig().queryClient.invalidateQueries({
    queryKey: [GET_WORKSPACE_INVITATIONS],
  });

/**
 * Lists the authenticated user's pending workspace invitations. Backs the
 * workspace-switcher "Invites" section (MUL-2644) and is invalidated by
 * `invalidateWorkspaceInvitations` after an accept. Mirrors
 * `useQueryWorkspaces`: `skipToken` when unauthenticated, and a 400 settles
 * immediately (unprovisioned user — won't self-heal) while genuine transient
 * failures (5xx / network) retry up to 3×.
 */
export function useQueryWorkspaceInvitations() {
  const token = getWorkspaceDataConfig().useAuthToken();

  return useQuery<ListWorkspaceInvitationsResponse>({
    queryKey: [GET_WORKSPACE_INVITATIONS],
    queryFn: token ? () => listWorkspaceInvitations() : skipToken,
    staleTime: 60 * 1000,
    retry: (failureCount, error: unknown) => {
      if (isTransportError(error) && error.response?.status === 400) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
